import {
  API,
  azureEngineServiceUrl,
  cloudAccountServiceUrl,
  type CloudType,
} from '@labrav/common'

export {
  fetchFlyoutAccountDetails,
  fetchOrganizationAccounts,
  getUrlFromCloudAccount,
  sendAzureData,
  sendAzurePartnerData,
} from '@labrav/common'

export const sendAzureSolutionsData = (
  dataToSend: Record<string, unknown>,
  partnerId: string
) => {
  return API.put(
    `${azureEngineServiceUrl}/partners/${partnerId}/solutions`,
    dataToSend
  )
}

export const postFlyoutAccountDetails = (data: Record<string, unknown>) => {
  return API.post(`${cloudAccountServiceUrl}/accounts`, data)
}

export const patchAccount = (accountId: string, data: unknown) => {
  return API.patch(`${cloudAccountServiceUrl}/accounts/${accountId}`, data)
}

export const testTemplateEndpoint = (
  templateId: string,
  cloudType: CloudType | string,
  iamRoleArn: string,
  partnerId: string
) => {
  return API.get(
    `${cloudAccountServiceUrl}/templates/${templateId}/verifications`,
    {
      params: {
        cloud_type: cloudType,
        iam_role_arn: iamRoleArn,
        partner_id: partnerId,
      },
    }
  )
}
